export default {
    apiUrl: 'https://financialmodelingprep.com/api',
    apiKey: 'd8ed336ddcddad19f8ed0ab6333e6193',
    companies: [
        'BABA',
        'AAPL',
        'FB',
        'GOOG',
        'ADBE',
        'AMZN',
        'HOG',
        'CSCO',
        'DIS',
        'KO',
        'INTC',
        'MA',
    ]
};
